<template>
  <ModalContainer
    v-model="modal"
    image='streak/fire.png'
    :title='title'
    button='Continue'
    @button-click='goToNext()'
    :disableClose='true'
  >
    <p>Go to bed before {{ target }} to keep your streak alive.</p>
    <StreakComponent/>
  </ModalContainer>
</template>

<script>
import ModalContainer from '@/components/ModalContainer'
import StreakComponent from '@/components/StreakComponent'
import { time24To12, dateToday } from '@/helpers/time'
import Modal from '@/models/modal'
import { mapStores } from 'pinia'
import { usePlanStore } from '@/stores/plan'
import { useModalStore } from '@/stores/modal'

export default {
  name: 'PlanStreak',
  components: {
    ModalContainer,
    StreakComponent,
  },
  data() {
    return {
      modal: true,
      target: undefined,
      stageIndex: undefined,
    }
  },
  beforeMount() {
    this.loadTarget()
  },
  watch: {
    modal: {
      handler() {
        if (this.modal === true) {
          localStorage.setItem('streak:viewed', dateToday())
        }
      },
      immediate: true,
    },
  },
  methods: {
    async loadTarget() {
      await this.planStore.load()
      const stage = this.planStore.activeStage
      this.stageIndex = this.planStore.activeStageIndex
      this.target = time24To12(stage?.target.bedTime)
    },
    goToNext() {
      this.modalStore.show(Modal.MODAL_TOOL, {
        toolObject: this.planStore.lastUnlockedTool,
        toolNew: true,
      })
      this.$router.push('/')
    },
  },
  computed: {
    title() {
      return this.stageIndex ? 'You started a streak for stage ' + this.stageIndex + '!' : ''
    },
    ...mapStores(usePlanStore, useModalStore),
  },
}
</script>